module.exports = __webpack_public_path__ + "static/media/TAJ_BLANC_SANSOMBRE.83f0a140.svg";